import { ClientError, GraphQLClient } from 'graphql-request';
import { ADD_TO_CART, CREATE_CART, READ_CART, REMOVE_FROM_CART } from './graphql';
const cartContentEl = document.getElementById('react-cart-content');
export const cartContent = JSON.parse(cartContentEl ? cartContentEl.innerHTML : '{}');
const storeFrontApiClient = new GraphQLClient(`https://${process.env.SHOPIFY_STORE_ID}.myshopify.com/api/2021-10/graphql.json`, {
    headers: {
        'X-Shopify-Storefront-Access-Token': process.env.SHOPIFY_STOREFRONT_API_TOKEN,
    },
});
// TODO auto-remove the cart after checkout - how can we check, if the user has already purchased a cart, so we can remove it?
const LOCAL_STORAGE_KEY = 'KOSMOS_cartId';
export const toProductVariantGid = (merchandiseId) => btoa(`gid://shopify/ProductVariant/${merchandiseId}`);
let cartId = window.localStorage.getItem(LOCAL_STORAGE_KEY);
export async function createCart(merchandiseId) {
    const res = await storeFrontApiClient.request(CREATE_CART, {
        merchandiseId,
    });
    const { cart } = res.cartCreate;
    cartId = cart.id;
    window.localStorage.setItem(LOCAL_STORAGE_KEY, cartId);
    if (!cart) {
        return null;
    }
    setCartCount(cart.lines?.edges?.length ?? 0);
    return cart;
}
function showAddToCartModal(message) {
    const addToCardModalEl = document.getElementById('add-to-cart-modal-container');
    const addToCardModal = document.querySelector('.add-to-cart-modal');
    if (addToCardModalEl) {
        addToCardModal.classList.add('is-visible');
        const closeButton = addToCardModalEl.querySelector('.btn-close');
        const modalContent = addToCardModalEl.querySelector('.message');
        modalContent.innerHTML = message;
        const modalTimeout = setTimeout(() => {
            addToCardModal.classList.remove('is-visible');
        }, 6000);
        closeButton.addEventListener('click', () => {
            clearTimeout(modalTimeout);
            addToCardModal.classList.remove('is-visible');
        });
    }
}
export async function addToCart(merchandiseId) {
    // Check if the current cart is still active
    let currentCart = null;
    if (cartId) {
        try {
            currentCart = await getCart();
        }
        catch (e) {
            // TODO we should log this in some way
        }
    }
    if (currentCart === null || currentCart.lines.edges.length === 0) {
        // User currently has no cart, simply create a new one with the product as only entry
        showAddToCartModal('Der Artikel wurde zu Ihrem Warenkorb hinzugefügt.');
        return createCart(merchandiseId);
    }
    if (currentCart.lines.edges.find(entry => entry.node.merchandise.id === merchandiseId)) {
        // Product already exists, return the cart as-is
        showAddToCartModal('Der Artikel ist bereits in Ihrem Warenkorb.');
        return currentCart;
    }
    const res = await storeFrontApiClient.request(ADD_TO_CART, {
        cartId,
        merchandiseId,
    });
    showAddToCartModal('Der Artikel wurde zu Ihrem Warenkorb hinzugefügt.');
    setCartCount(res.cartLinesAdd.cart.lines?.edges?.length ?? 0);
    return res.cartLinesAdd.cart;
}
export async function removeFromCart(lineId) {
    const res = await storeFrontApiClient.request(REMOVE_FROM_CART, {
        cartId,
        lineId,
    });
    setCartCount(res.cartLinesRemove.cart.lines?.edges?.length ?? 0);
    return res.cartLinesRemove.cart;
}
export async function getCart() {
    if (!cartId) {
        return null;
    }
    try {
        const res = await storeFrontApiClient.request(READ_CART, { cartId });
        setCartCount(res.cart.lines?.edges?.length ?? 0);
        return res.cart;
    }
    catch (e) {
        if (e instanceof ClientError && e.response.errors.length > 0) {
            // TODO we should log this either way
            console.error(e);
        }
        throw e;
    }
}
export async function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
        if (count === 0) {
            el.classList.add('is-empty');
        }
        else {
            el.textContent = count.toString();
            el.classList.remove('is-empty');
        }
    });
}
